
$(window).on('load', function(){
	$('[data-ckeditor]').each(function(){
		ckeditor_load($(this))
	})
})

// var allowedContentCommon = true;
var allowedContentCommon =
	'div(*){*};'+
	'p(*){*};'+
	'span(*){*};'+
	'strong(*);'+
	'em(*);'+
	'u(*);'+
	's(*);'+
	'a(*)[!href];'+ // hrefが入ってないAタグは無視するという意味
	'img(*)[*];'+
	'table(*)[*];'+
	'thead(*)[*];'+
	'tbody(*)[*];'+
	'tfoot(*)[*];'+
	'tr(*)[*];'+
	'th(*)[*];'+
	'td(*)[*];'+
	'caption(*)[*];'+
	'ul(*);'+
	'ol(*);'+
	'li(*);'+
	'dl(*);'+
	'dt(*);'+
	'dd(*);'+
	'blockquote(*);'
;

function ckeditor_load($target)
{
	// __BASE__取得
	var __BASE__ = $('base').attr('href').replace(/\/$/, '')

	// 画像フリーエリア
	if ('performance-free-images' === $target.data('ckeditor')) {

		var cke = CKEDITOR.replace($target.get(0),
			{
				allowedContent: allowedContentCommon,

				enterMode: CKEDITOR.ENTER_BR,
				shiftEnterMode: CKEDITOR.ENTER_P,

				versionCheck: false,

				// editor id
				contentsCss: __BASE__+'/assets/css/add-ckeditor.css',

				// style set
				// stylesSet: 'my_styles',

				// // icons
				// toolbarGroups: [
				// 	// { name: 'styles', groups: ['styles'] },
				// 	// { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
				// 	// { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
				// 	// { name: 'forms',       groups: [ 'forms' ] },
				// 	{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
				// 	{ name: 'colors', groups: ['colors'] },
				// 	// { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
				// 	{ name: 'links', groups: ['links'] },
				// 	{ name: 'insert', groups: ['insert'] },
				// 	// { name: 'tools',       groups: [ 'tools' ] },
				// 	// { name: 'others',      groups: [ 'others' ] },
				// 	// { name: 'about',       groups: [ 'about' ] },
				// 	{ name: 'document', groups: ['mode', 'document', 'doctools'] }
				// ],

				toolbar: [
					['Bold','Italic','Underline','Strike','RemoveFormat'],
					['TextColor','JustifyLeft','JustifyCenter','JustifyRight'],
					['Link','Unlink'],
					['Image', 'Table'],
					['Source'],
				],

				removeButtons: 'Templates,Save,NewPage,Preview,Print,Cut,Undo,Redo,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,NumberedList,BidiLtr,BidiRtl,Language,Anchor,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Font,Format,FontSize,ShowBlocks,Maximize,About,BGColor',

				// for KCFinder
				filebrowserBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=files',
				filebrowserImageBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=images',
				filebrowserFlashBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=flash',
				filebrowserUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=files',
				filebrowserImageUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=images',
				filebrowserFlashUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=flash',
				filebrowserUploadMethod: 'form',

				// plugins
				extraPlugins: 'autogrow,widget,lineutils,image2,justify,colorbutton',
				removePlugins: 'image',

				// plugin: Auto Grow
				autoGrow_minHeight: 200,
				autoGrow_maxHeight: 600,
				autoGrow_bottomSpace: 50,

				// templates
				templates: 'default',
			})
		;
		$target.data('cke', cke)
	}

	// 公演情報詳細
	if ('performance-detail' === $target.data('ckeditor')) {

		var cke = CKEDITOR.replace($target.get(0),
			{
				allowedContent: allowedContentCommon,

				enterMode: CKEDITOR.ENTER_BR,
				shiftEnterMode: CKEDITOR.ENTER_P,

				versionCheck: false,

				// editor id
				contentsCss: __BASE__+'/assets/css/add-ckeditor.css',

				// style set
				// stylesSet: 'my_styles',

				// icons
				// toolbarGroups: [
				// 	// { name: 'styles', groups: ['styles'] },
				// 	// { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
				// 	// { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
				// 	// { name: 'forms',       groups: [ 'forms' ] },
				// 	{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
				// 	{ name: 'colors', groups: ['colors'] },
				// 	// { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
				// 	{ name: 'links', groups: ['links'] },
				// 	{ name: 'insert', groups: ['insert'] },
				// 	// { name: 'tools',       groups: [ 'tools' ] },
				// 	// { name: 'others',      groups: [ 'others' ] },
				// 	// { name: 'about',       groups: [ 'about' ] },
				// 	{ name: 'document', groups: ['mode', 'document', 'doctools', 'Recommend'] },
				// 	{ name: 'custom', items: ['Recommend'] }
				// ],

				toolbar: [
					['Bold','Italic','Underline','Strike','RemoveFormat'],
					['TextColor','JustifyLeft','JustifyCenter','JustifyRight'],
					['Link','Unlink'],
					['Image', 'Table'],
					['Source', 'Recommend'],
				],

				removeButtons: 'Templates,Save,NewPage,Preview,Print,Cut,Undo,Redo,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,NumberedList,BidiLtr,BidiRtl,Language,Anchor,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Font,Format,FontSize,ShowBlocks,Maximize,About,BGColor',

				// for KCFinder
				filebrowserBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=files',
				filebrowserImageBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=images',
				filebrowserFlashBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=flash',
				filebrowserUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=files',
				filebrowserImageUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=images',
				filebrowserFlashUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=flash',
				filebrowserUploadMethod: 'form',

				// plugins
				extraPlugins: 'autogrow,widget,lineutils,image2,justify,colorbutton',
				removePlugins: 'image',

				// plugin: Auto Grow
				autoGrow_minHeight: 200,
				autoGrow_maxHeight: 600,
				autoGrow_bottomSpace: 50,
			})
		;

		// 公演詳細テーブルの雛形挿入ボタン
		cke.on('pluginsLoaded', function(ev){
			// 各ボタンの定義
			this.ui.addButton('Recommend', {
				label: '雛形挿入', command: 'recommend', icon: __BASE__+'/assets/images/ico_template.png'
			});
			this.addCommand('recommend', {
				exec: function(editor) {
					editor.insertHtml(
						'<table class="txt"><tr><th>公演日時</th><td>[schedule]</td></tr><tr><th>会場</th><td></td></tr><tr><th>料金</th><td></td></tr><tr><th>チケット発売日</th><td></td></tr><tr><th>備考</th><td></td></tr><tr><th>お問合せ</th><td></td></tr></table>'
					);
				}
			});
		});


		$target.data('cke', cke)
	}

	// その他自由入力
	if ('free-content' === $target.data('ckeditor')) {

		var cke = CKEDITOR.replace($target.get(0),
			{
				allowedContent: allowedContentCommon,

				enterMode: CKEDITOR.ENTER_BR,
				shiftEnterMode: CKEDITOR.ENTER_P,

				versionCheck: false,

				// editor id
				contentsCss: __BASE__+'/assets/css/add-ckeditor.css',

				// style set
				// stylesSet: 'my_styles',

				// icons
				// toolbarGroups: [
				// 	// { name: 'styles', groups: ['styles'] },
				// 	// { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
				// 	// { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
				// 	// { name: 'forms',       groups: [ 'forms' ] },
				// 	{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
				// 	{ name: 'colors', groups: ['colors'] },
				// 	// { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
				// 	{ name: 'links', groups: ['links'] },
				// 	{ name: 'insert', groups: ['insert'] },
				// 	// { name: 'tools',       groups: [ 'tools' ] },
				// 	// { name: 'others',      groups: [ 'others' ] },
				// 	// { name: 'about',       groups: [ 'about' ] },
				// 	{ name: 'document', groups: ['mode', 'document', 'doctools'] }
				// ],

				toolbar: [
					['Bold','Italic','Underline','Strike','RemoveFormat'],
					['TextColor','JustifyLeft','JustifyCenter','JustifyRight'],
					['Link','Unlink'],
					['Image', 'Table'],
					['Source'],
				],

				removeButtons: 'Templates,Save,NewPage,Preview,Print,Cut,Undo,Redo,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Subscript,Superscript,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,NumberedList,BidiLtr,BidiRtl,Language,Anchor,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Font,Format,FontSize,ShowBlocks,Maximize,About,BGColor',

				// for KCFinder
				filebrowserBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=files',
				filebrowserImageBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=images',
				filebrowserFlashBrowseUrl: __BASE__+'/assets/libs/kcfinder/browse.php?type=flash',
				filebrowserUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=files',
				filebrowserImageUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=images',
				filebrowserFlashUploadUrl: __BASE__+'/assets/libs/kcfinder/upload.php?type=flash',
				filebrowserUploadMethod: 'form',

				// plugins
				extraPlugins: 'autogrow,widget,lineutils,image2,justify,colorbutton',
				removePlugins: 'image',

				// plugin: Auto Grow
				autoGrow_minHeight: 200,
				autoGrow_maxHeight: 600,
				autoGrow_bottomSpace: 50,
			})
		;
		$target.data('cke', cke)
	}
}
